import { useServices } from '@/components/ServiceContext.tsx';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage.tsx';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const StaffSeedReport: React.FC = () => {
  const { staffSeedService } = useServices();

  const report = reportDefinitions.find(rd => rd.id === 'report-staff-seed');

  return (
    report && (
      <GenericReportPage
        listType="staffseed"
        listService={staffSeedService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default StaffSeedReport;
